import React, {useState} from "react";
import {useWishlistContext} from "./WishlistContextProvider/WishlistContextProvider";
import WishlistItem from "./WishlistItem/WishlistItem";
import {useTranslation} from "react-i18next";
import styles from "./Wishlist.module.scss";
import {getShopId} from "../lib/getShopId";
import {useCustomerContext} from "../customer/CustomerContextProvider/CustomerContextProvider";

const Wishlist: React.FC = () => {
  const {wishlist} = useWishlistContext();
  const {t} = useTranslation("customerAccount");
  const [maxItems, setMore] = useState(20);
  const {customer} = useCustomerContext();

  const wishlistDiv = document.getElementsByClassName("wishlist")[0];
  const spinner = document.querySelector(".wishlist > .swiper-lazy-preloader");
  if (spinner) {
    wishlistDiv.removeChild(spinner);
  }

  // show content when no items exists and the customer is logged in
  if (!wishlist?.items.length && customer.isLoggedIn) {
    return (
      <div className={styles.noListWrapper}>
        {t("Derzeit befinden sich keine Artikel auf Ihrer Wunschliste.")}
        <br />
        {t("Lassen Sie sich von unserer Produktvielfalt inspirieren.")}
        <br />
        <a href={window.location.origin}>
          {t("Jetzt Designlieblinge finden").replace("favourites", getShopId() === 10005 ? "favorites" : "favourites")}
        </a>
      </div>
    );
  }

  if (!wishlist?.items.length) {
    return null;
  }

  const itemsSortByModified = wishlist?.items.sort((a, b) => {
    if (a.modified < b.modified) {
      return 1;
    } else if (a.modified > b.modified) {
      return -1;
    } else {
      return 0;
    }
  }) || [];

  return (
    <React.Fragment>
      {/*/ sorted wishlist items */}
      <div>
        {itemsSortByModified.map((item, index) => {
          if (index < maxItems) {
            return <WishlistItem key={item.item.itemId} item={item} />;
          } else {
            return null;
          }
        })}
      </div>

      {/*/ "mehr laden" button  */}
      {itemsSortByModified.length > maxItems && (
        <div className={styles.moreButtonWrapper}>
          <div
            className={styles.moreButton}
            onClick={() => {
              setMore(itemsSortByModified.length);
            }}
          >
            {t("Alle Wunschlisten-Artikel anzeigen")}
          </div>
        </div>
      )}
    </React.Fragment>
  );
};

export default Wishlist;
